<template>
	<div>
		<div class="content top">
			<div>MICP联盟</div>
			<div>
				<span>MICP联盟简介</span>
				<span>MICP联盟倡议书</span>
			</div>
		</div>
		<div class="banner">
			<img src="../assets/banner.jpg">
		</div>
		<div class="content">
			<div class="lmAbout">
				<div class="lmJj">
					<div class="lmTit">MICP联盟简介</div>
					<div class="lmDe">
						MICP联盟，全称为MICP企业服务联盟，是在各部委及各地方政府的政策指导下，由行业监管机构携手各省市县企事业单位、龙头企业及行业标杆组织共同发起成立的一个具有深远影响力的组织。该联盟汇聚了各区域运营服务商、技术开发服务商以及渠道运营推广企业等多元力量，致力于为中国广大中小微企业提供全方位的技术扶持与创新服务。</br>
						
						MICP联盟的组织架构清晰明了，由常务理事成员、普通理事成员及秘书处共同构成。这一架构确保了联盟的高效运作与决策的精准实施。通过数字化示范平台、数字门店、社交电商、试听直播、新媒体saas系统、企业官媒认证等项目平台与产品服务，联盟为中小微企业提供了强大的技术支持与业务创新动力。</br>
						
						在MICP联盟的支持下，企业可以迅速实现自媒体与新媒体的数字化转型，提升品牌影响力与市场竞争力。联盟更致力于通过每个区域、每个行业的示范平台标杆建设，引领区域内企业真正实现数字化经济转型，为行业的整体升级注入强大动力。</br>
						
						值得一提的是，MICP联盟作为行业监管服务机构，设立了严格的加入机制与退出机制。这一机制确保了联盟成员的质量与服务的专业性，同时也为联盟的长远发展提供了坚实保障。关于联盟的更多详情与深入信息，可通过MICP联盟倡议书进行了解。</br>
						
						MICP联盟不仅是一个服务平台的提供者，更是企业数字化转型的引领者与推动者。在未来，联盟将继续携手各方力量，共同推动中国中小微企业在数字化道路上走得更远、更稳。
					</div>
					
				</div>
				<div class="lmCys">
					<div class="lmTit">MICP联盟倡议书</div>
					<div class="lmDe">
						尊敬的各位行业监管机构、企事业单位、龙头企业及行业标杆组织：</br>
						
						我们生活在一个信息化、数字化快速发展的时代，移动互联网、新媒体等新兴领域正在深刻改变着我们的生活和工作方式。为了更好地适应这一变革，推动中国中小微企业实现数字化转型，提升整体竞争力，我们特发起成立MICP联盟。</br>
						
						MICP联盟将汇聚各方力量，共同打造一个资源共享、互利共赢的平台。我们诚挚邀请各位行业监管机构、企事业单位、龙头企业及行业标杆组织，携手合作，共谋发展。</br>
						
						一、联盟组成</br>
						
						MICP联盟由行业监管机构携手各省市县企事业单位、龙头企业及行业标杆组织共同发起成立。常务理事成员由行业监管机构携手企事业单位牵头龙头企业及行业标杆自发组成，共同为联盟的发展提供战略指导和支持。理事成员由各省市县从事移动互联网、新媒体等相关的技术开发性企业、新媒体运营推广性企业、渠道推广与普及工作性质的企业自愿申请加入，共同推动联盟的各项工作。秘书处由常务理事与理事成员共同选举产生秘书长与副秘书长以及办公室主任等岗位，负责联盟的日常运营和管理工作。</br>
						
						二、联盟宗旨</br>
						
						MICP联盟的宗旨是为广大中小微企业提供全方位的技术扶持、模式创新、资金激励等相关服务，帮助企业实现数字化转型，提升市场竞争力。我们将通过数字化示范平台、数字门店、社交电商、试听直播、新媒体saas系统、企业官媒认证等项目平台与产品服务，为企业提供一站式解决方案。</br>
						
						三、成员权益与责任</br>
						
						凡是加入MICP联盟的成员均需自愿遵守本联盟的相关规章制度以及服务宗旨。常务理事成员可通过联盟为企业提供项目/平台以及产品服务，推动行业创新与发展。普通理事成员享有共同推动宣传联盟的项目/平台以及产品服务给广大中小企业的责任，为广大中小微企业提供技术扶持、模式创新、资金激励等相关服务。</br>
						
						四、联系方式</br>
						
						为方便各成员单位之间的沟通与联系，我们设立了专门的申请及投诉邮箱（kf@micp.org.cn）和官方客服热线（400-875-1066）。请各成员单位在使用过程中保持警惕，甄别信息是否真实可靠，谨慎决策，避免不必要的损失。</br>
						
						我们坚信，通过大家的共同努力和支持，MICP联盟一定能够成为中国中小微企业数字化转型的重要力量，为推动我国经济发展做出积极贡献。让我们携手并进，共创美好未来！</br>
						
						敬请各位领导、专家、企业家及社会各界人士关注和支持MICP联盟的发展，共同见证中国中小微企业的数字化转型之路！</br>
						
						此致 敬礼！</br>
						
						MICP联盟筹备组 日期：2024年4月7日
					</div>
				</div>
			</div>
			
		</div>
		<div class="lmLs">
			<div class="content">
				<div class="ms">
					<div class="lsTit">{{infoData[0].name}}</div>
					<div class="lsList">
						<span v-for="(item,index) in infoData[0].list">{{item.site}}: {{item.name}}</span>
					</div>
				</div>
				<div class="lmCw">
					<div class="lsTit">{{infoData[1].name}}</div>
					<div class="lsList">
						<span v-for="(item,index) in infoData[1].list">{{item}}</span>
					</div>
				</div>
				<div class="lmPt">
					<div class="lsTit">{{infoData[2].name}}</div>
					<div class="lsList">
						<span v-for="(item,index) in infoData[2].list">{{item}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return{
				infoData:[]
			}
		},
		mounted() {
			this.info()
		},
		methods:{
			info(){
				this.$http.post('https://api.iptzx.com/crmapi/getMsg',{
				}).then(res=>{
					// console.log(res)
					var data=res.data
					this.infoData=res.data
					// console.log(this.infoData)
				}).catch(err=>{
					console.log(err)
				})
			}
		}
	}
</script>

<style>
	*
	{
		margin: 0;
		padding: 0;
	}
	ul
	{
		list-style: none;
	}
	img
	{
		display: block;
	}
	.top
	{
		font-size: 24px;
		color: #333;
		padding: 30px 0;
		display: flex;
		justify-content: space-between;
	}
	.top span
	{
		margin-left: 20px;
	}
	.banner
	{
		width: 100%;
		max-width: 1920px;
		margin: auto;
	}
	.banner img
	{
		width: 100%;
	}
	.content
	{
		width: 1200px;
		margin: auto;
	}
	.lmAbout
	{
		overflow: hidden;
		margin-top: 80px;
	}
	.lmAbout>div
	{
		/* width: 50%;
		float: left; */
		margin-bottom: 60px;
		box-sizing: border-box;
	}
	.lmTit
	{
		font-size: 36px;
		color: #333;
		font-weight: bold;
		text-align: center;
	}
	.lmDe
	{
		font-size: 20px;
		color: #333;
		margin-top: 40px;
		line-height: 42px;
	}
	.lmJj
	{
		padding-right: 10px;
	}
	.lmCys
	{
		padding-left: 10px;
	}
	/* .lmJj .lmDe
	{
		line-height: 30px;
	}
	.lmCys .lmDe
	{
		line-height: 30px;
	} */
	.lmLs
	{
		width: 100%;
		max-width: 1920px;
		background: #0f2948;
		padding: 30px 0;
		color: #fff;
	}
	.lmLs .content
	{
		background: #0f2948;
		
	}
	.lsTit
	{
		font-size: 24px;
	}
	.lmCw,.lmPt,.ms
	{
		margin-bottom: 40px;
	}
	.lsList
	{
		font-size: 20px;
		margin-top: 20px;
	}
	.lsList span
	{
		margin-right: 20px;
	}
	@media screen and (max-width:680px) {
		.banner
		{
			/* width: 1200px; */
		}
		.content
		{
			width: 100%;
			padding: 0 2vw;
			box-sizing: border-box;
		}
		.top
		{
			padding: 3vh 2vw;
			font-size: 14px;
			box-sizing: border-box;
		}
		.top span
		{
			margin-left: 2vw;
		}
		.lmAbout
		{
			margin-top: 6vh;
			
		}
		.lmAbout>div
		{
			padding: 0;
			margin-bottom: 4vh;
		}
		.lmTit
		{
			font-size: 20px;
		}
		.lmDe
		{
			margin-top: 3vh;
			font-size: 14px;
			line-height: 24px;
		}
		.lmLs
		{
			padding: 2vh 0;
		}
		.lmCw, .lmPt, .ms
		{
			margin-bottom: 3vh;
		}
		.lsList
		{
			font-size: 14px;
			margin-top: 2vh;
		}
		.lsTit
		{
			font-size: 16px;
		}
		.lmLs .content>div:last-child
		{
			margin-bottom: 0;
		}
	}
</style>